export const LicenseListRouting = [
  {
    path: "/license-manage/license-list/list",
    name: "license-list-list",
    meta: { title: "证照列表" },
    component: () => import("@/views/license-manage/license-list/list/index.vue"),
  }
];
